"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionProductType = exports.SubscriptionStatus = exports.SubscriptionBillingInterval = exports.SubscriptionSource = void 0;
var zod_1 = require("zod");
exports.SubscriptionSource = zod_1.z.enum(['apple', 'amazon', 'google', 'roku', 'web']);
exports.SubscriptionBillingInterval = zod_1.z.enum(['monthly', 'annual', 'manual']);
exports.SubscriptionStatus = zod_1.z.enum([
    'active',
    'canceled',
    'expired',
    'paused',
    'seasonal_paused'
]);
exports.SubscriptionProductType = zod_1.z.enum([
    'package-base',
    'package-bundle',
    'package-seasonal'
]);
